(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presale-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('presale-countdown')) {
    customElements.define('presale-countdown', class extends HTMLElement {
      connectedCallback() {
        const raw = this.dataset.deadline || '';
        if (!/T.*(?:Z|[+-]\d{2}:\d{2})$/.test(raw)) return;
        const end = Date.parse(raw);
        if (!Number.isFinite(end)) return;
        const tick = () => {
          const remaining = Math.ceil((end - Date.now()) / 1000);
          if (remaining <= 0) {
            this.hidden = true;
            clearInterval(this.interval);
            return false;
          }
          this.querySelector('[data-hours]').textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
          this.querySelector('[data-minutes]').textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
          this.querySelector('[data-seconds]').textContent = String(remaining % 60).padStart(2, '0');
          this.querySelector('[role="timer"]').hidden = false;
          return true;
        };
        if (tick()) this.interval = setInterval(tick, 1000);
      }
      disconnectedCallback() { clearInterval(this.interval); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["presale-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('presale-offer')) {
    customElements.define('presale-offer', class extends HTMLElement {
      connectedCallback() {
        const query = new URLSearchParams(window.location.search);
        const allowed = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid'];
        this.querySelectorAll('[data-offer-link]').forEach(link => {
          const url = new URL(link.href, window.location.origin);
          allowed.forEach(key => { if (query.has(key)) url.searchParams.set(key, query.get(key)); });
          link.href = url.toString();
        });
        this.sticky = this.querySelector('[data-offer-sticky]');
        if (!this.sticky) return;
        this.card = this.querySelector('[data-offer-card]');
        this.mobile = window.matchMedia('(max-width:749px)');
        this.update = () => {
          const opening = document.querySelector('.presale-opening');
          const pastOpening = opening ? opening.getBoundingClientRect().bottom <= 0 : window.scrollY > 400;
          const bounds = this.card.getBoundingClientRect();
          const cardVisible = bounds.top < window.innerHeight && bounds.bottom > 0;
          this.sticky.hidden = !this.mobile.matches || !pastOpening || cardVisible;
        };
        this.onScroll = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); }); };
        window.addEventListener('scroll', this.onScroll, {passive:true});
        window.addEventListener('resize', this.onScroll, {passive:true});
        this.observer = new IntersectionObserver(this.update);
        this.observer.observe(this.card);
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
